const BASE_URL = process.env.REACT_APP_BASE_URL ?? '';

export const SOCKET_URL = `${BASE_URL}/board`;
export const CARD_COMMENT_SOCKET_URL = `${BASE_URL}/comments`;
export const CARD_DETAILS_SOCKET_URL = `${BASE_URL}/card-details`;
